import { RegionShared } from "@1games-ru/region-shared";
import { useEffect, useState } from "react";
import rpc from "@1games-ru/rage-rpc";

export default function useShowHints() {
  const [isShowHints, setIsShowHints] = useState(true);

  useEffect(() => {
    rpc.register(RegionShared.Cef.Events.Hud.SetHudHintsShow, (state: boolean) => {
      setIsShowHints(state);
    });

    return () => {
      rpc.unregister(RegionShared.Cef.Events.Hud.SetHudHintsShow);
    };
  });

  return {
    isShowHints,
  };
}
